export default __webpack_public_path__ + "static/media/savings.64e6f800.svg";